import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import ErrorView from "../components/Error";
import Footer from "../Footer";
import axios from "axios";
import { ReactComponent as Spinner } from "../assets/images/spinner.svg";
import dayjs from "dayjs";
import Subscribe from "../components/Subscribe";
import { isMobile, clearAllTestStorage } from "../utils";
import { useNewTest } from "../hooks/useNewTest";

function HomePage() {
	let history = useHistory();
	const { t } = useTranslation();

	const [status, setStatus] = useState("loading");
	const [state, setState] = useState(null);
	const { create } = useNewTest();

	const createAndRedirectTo = async (e) => {
		e.preventDefault();
		clearAllTestStorage();

		if (isMobile()) {
			alert(t("You need to start with a PC/Mac browser, not mobile"));
			return;
		}

		const test = await create();
		history.push({
			pathname: "/test/connection",
			search: "?token=" + test.token,
		});
	};

	const getStatus = (status) => {
		const intStatus = parseInt(status);
		if (intStatus === 3) return t("Waiting Payment");
		if (intStatus === 4) return t("Expert Validation");
		if (intStatus > 4) return t("Active");
		return t("Trial");
	}
	
	useEffect(() => {
		axios
			.get(`${process.env.REACT_APP_API}/user/tests`, {
				withCredentials: true,
			})
			.then(function (res) {
				if (res.data.result) {
					setState(res.data);
					setStatus("done");
				} else {
					setStatus("error");
				}
			})
			.catch((e) => {
				setStatus("error");
			});
	}, []);

	return (
		<>
			<Header />

			<div className="content">
				<main className="user-page">
					<h1>{t("My Tests")}</h1>

					{status === "loading" ? (
						<div className="loading-view auto">
							<div className="spinner-wrapper">
								<Spinner />
							</div>
						</div>
					) : null}

					{status === "done" ? (
						<div className="tests-listing">
							{state?.tests?.length && (state.status === "active") ? (
								<table>
									<thead>
										<tr>
											<th width={"200"}>{t("Taken at")}</th>
											<th>{t("Name")}</th>
											<th>{t("E-mail")}</th>
											<th>{t("Status")}</th>
											<th width={"100"}>{t("Action")}</th>
										</tr>
									</thead>
									<tbody>
										{state.tests.map((item, index) => {
											return (
												<tr key={index}>
													<td>
														{dayjs(item.createdAt).format(
															"MM/DD/YYYY - HH:mm:ss"
														)}
													</td>
													<td>{item.name}</td>
													<td>{item.email}</td>
													<td>{getStatus(item.step)}</td>
													<td>
														<a
															href="#view"
															className="btn-view"
															onClick={(e) => {
																e.preventDefault();
																history.push({ pathname: `/exam/${item._id}` });
															}}
														>
															{t("View")}
														</a>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							) : null}

							{(state.tests?.length > 0 && !state.status) && state?.status !== "active" ? (
								<Subscribe />
							) : null}
							{!state?.tests?.length && state.status === "active" ? (
								<div className="no-tests">
									<h4>{t("You haven't taken any tests yet.")}</h4>
									<button className="button" onClick={async (e) => await createAndRedirectTo(e)}>{t("Start now")}</button>
								</div>
							) : null}
							{state?.tests?.length < 1 && state?.status !== "active" ? (
								<Subscribe />
							) : null}
						</div>
					) : null}

					{status === "error" && <ErrorView />}
				</main>
			</div>
			<Footer />
		</>
	);
}

export default HomePage;
